import React, { useEffect, useMemo } from 'react';
import SystemInterface from '../components/SystemInterface';
import AshBoot from './AshBoot';


const DAY_14 = 14 * 24 * 60 * 60 * 1000;

const decideIntro = () => {
  const params = new URLSearchParams(window.location.search);
  const forced = params.get('intro');

  if (['FULL', 'RECONNECT_1', 'RECONNECT_2', 'RECONNECT_3'].includes(forced)) {
    return forced;
  }

  const last = Number(localStorage.getItem('lastVisit') || 0);
  const step = Number(localStorage.getItem('reconnectStep') || 0);
  const now = Date.now();
  const diff = now - last;

  if (!last) {
    localStorage.setItem('reconnectStep', 1);
    return 'FULL';
  }

  if (diff < DAY_14) {
    const play = `RECONNECT_${Math.min(step, 3)}`;
    localStorage.setItem('reconnectStep', Math.min(step + 1, 3));
    return play;
  }

  localStorage.setItem('reconnectStep', 1);
  return 'FULL';
};

export default function ArchiveHandshake() {
  const choice = useMemo(decideIntro, []);

  useEffect(() => {
    const animateSign = choice === 'FULL';

    window.dispatchEvent(
      new CustomEvent('archiveIntroState', {
        detail: {
          choice,
          animateSign
        }
      })
    );

    if (choice !== 'NONE') {
      localStorage.setItem('lastVisit', Date.now());
    }
  }, [choice]);

  switch (choice) {
    case 'FULL':
      return <AshBoot />;

    case 'RECONNECT_1':
      return (
        <SystemInterface
          initialMessages={require('../data/Reconnect_GG_RE01').reconnect1Data}
          theme="ash"
        />
      );

    case 'RECONNECT_2':
      return (
        <SystemInterface
          initialMessages={require('../data/Reconnect_LOL_SNAFU02').reconnect2Data}
          theme="ash"
        />
      );

    case 'RECONNECT_3':
      return (
        <SystemInterface
          initialMessages={require('../data/Reconnect_AFK03').reconnect3Data}
          theme="ash"
        />
      );

    default:
      return <AshBoot />;
  }
}